<template>
  <RouterLink to="/" class="brand-mark" :class="{ 'is-compact': compact }" aria-label="MarketWatcher Home">
    <img
      src="/logo.png"
      alt=""
      class="brand-mark-logo"
      width="32"
      height="32"
      :loading="eager ? 'eager' : 'lazy'"
      :fetchpriority="eager ? 'high' : 'auto'"
    />
    <span v-if="!compact" class="brand-mark-text">MarketWatcher</span>
  </RouterLink>
</template>

<script setup>
defineProps({
  compact: { type: Boolean, default: false },
  eager: { type: Boolean, default: false },
});
</script>

<style scoped>
.brand-mark {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--fg);
  font-weight: 700;
  letter-spacing: -0.02em;
  font-size: 17px;
  text-decoration: none;
}
.brand-mark:hover {
  color: var(--fg);
}
.brand-mark-logo {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  object-fit: contain;
}
@media (max-width: 480px) {
  .brand-mark.is-compact .brand-mark-text,
  .brand-mark:not(.is-compact) .brand-mark-text {
    display: none;
  }
}
</style>
